// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Check = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7">
            <polygon
                fill="currentColor"
                points="9 .744 8.658 1.115 3.566 6.63 3.226 7 2.887 6.63 .342 3.873 0 3.503 .681 2.76 1.023 3.129 3.226 5.517 7.977 .37 8.319 0 9 .744"
            />
        </svg>
    );
};

export default React.memo(Check);
